import script from "./AiTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./AiTooltip.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__